<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--xl">Menus</h1>

    <div class="dashboard-shortcuts">
      <router-link
        to="/app/menus/orientacoes"
        class="dashboard-shortcut mdn-Shortcut mdn-Shortcut--secondary"
        aria-label="Shortcut clicável"
      >
        <i class="mdn-Shortcut-icon mdn-Icon-chat mdn-Icon--md"></i>
        <p class="mdn-Shortcut-text">Orientações sobre menus</p>
      </router-link>

      <router-link
        to="/app/menus"
        class="mdn-Shortcut mdn-Shortcut--secondary"
        aria-label="Shortcut clicável"
      >
        <i class="mdn-Shortcut-icon mdn-Icon-chat mdn-Icon--md"></i>
        <p class="mdn-Shortcut-text">Editar e criar menus</p>
      </router-link>

      <router-link
        to="/app/menus/menu-x-perfil"
        class="mdn-Shortcut mdn-Shortcut--secondary"
        aria-label="Shortcut clicável"
      >
        <i class="mdn-Shortcut-icon mdn-Icon-chat mdn-Icon--md"></i>
        <p class="mdn-Shortcut-text">Visão de menus por perfil</p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrincipalPage",
};
</script>

<style lang="scss" scoped>
.dashboard-shortcuts {
  display: flex;
  align-content: space-around;
  justify-content: left;
  flex-wrap: wrap;
  flex-direction: row;

  a {
    display: flex;
    align-self: flex-end;
    margin: 5px;
  }
}
</style>
